<template>
    <div class="student-login" :style="{background: examInfo.bg_image?`url(${examInfo.bg_image}) 100% 100% no-repeat`:`url(${defaultBg}) 100% 100% no-repeat`}">
        <div class="login-title">{{examInfo.name}}</div>
        <img class="tc1" src="../assets/studentLogin/tc1.png">
        <img class="tc2" src="../assets/studentLogin/tc1.png">
            <div class="form-body">
                <div class="content">
                    <div v-if="examInfo.exam_status===0||examInfo.exam_status===2" class="tips">{{Number(examInfo.exam_status)===0?'考试暂未开始':'考试已结束'}}</div>
                    <div v-if="Number(examInfo.exam_status)===1&&examInfo.score===''" class="info">
                        <div class="name">姓名：{{userInfo.username}}</div>
                        <div class="name" style="left: 300px;">身份证：{{userInfo.id_number}}</div>
                        <div class="detail task-detail">
                            <div>
                                <span>总分:</span>
                                <span><span class="blue">{{examInfo.total_score}}</span>分</span>
                            </div>
                            <div>
                                <span>通过线:</span>
                                <span><span class="blue">{{examInfo.pass_line}}</span>分</span>
                            </div>
                            <div v-if="examInfo.score!==''">
                                <span>综合成绩:</span>
                                <span><span class="blue">{{examInfo.is_pass}}</span></span>
                            </div>
                        </div>
                    </div>
                    <div v-if="Number(examInfo.exam_status)===1&&examInfo.score===''" class="handle">
                        <span v-if="examInfo.score!==''" class="active" @click="changeStatus('detail')">查看试卷详情</span>
                        <span v-if="examInfo.score===''" class="active" @click="changeStatus('exam')">开始考试</span>
                    </div>
                </div>
            </div>
    </div>
    
</template>
<script>
// import { MessageBox } from 'element-ui';
import { mapState } from 'vuex';


export default {
    data(){
        return {
            defaultBg: require('../assets/studentLogin/bg.png'),
        };
    },
    computed:mapState([
        'examInfo',
        'userInfo',
    ]),
    watch:{
        examInfo(){
            if(this.examInfo.exam_status===1&&this.examInfo.score!==''){
                this.$router.push('/')
            }
        }
    },
    mounted() {
        
    },
    methods: {
        changeStatus(mes){
            this.$emit('changeStatus',mes);
        }
    },
};
</script>
<style lang="scss" scoped>
.tips{
    text-align: center;
    font-weight: 700;
    font-size: 30px;
    padding-top: 100px;
}
.student-login{
    width: 100%;
    min-width: 1200px;
    height: 100vh;
    min-height: 600px;
    position: relative;
}
.tc1{
    width: 700px;
    height: 400px;
    position: absolute;
    top: calc(50% - 150px);
    left: calc(50% - 350px);
    z-index: 9;
}
.tc2{
    width: 660px;
    height: 360px;
    position: absolute;
    top: calc(50% - 130px);
    left: calc(50% - 330px);
    z-index: 99;
}


@import '../assets/user.scss';

.ext{
    position: relative;
    .ext-input{
        // width:80px;
    }
    .get-code{
        position: absolute;
        right: 135px;
        top: 20px;
        border-radius: 4px;
        padding: 6px 6px;
        background: #002c56;
        color: #fff;
        font-size: 13px;
    }
}
.control-label{
    font-family: Microsoft YaHei !important;
    font-weight: bold !important;
    color: #000000 !important;
}

.form-body{
    width: 400px;
    position: absolute;
    left: calc(50% - 200px);
    top: calc(50% - 70px);
    z-index: 999;
}
.my-btn{
    background: #002E67;
    padding: 5px 28px;
    border-radius: 3px;
    color: #fff;
    position: absolute;
    font-weight: bold;
    display: inline-block;
    bottom: -63px;
    left: 102px;
    cursor: pointer;
}
.reset-btn{
    border: 1px solid #002E67 !important;
    color: #002E67 !important;
    left: 278px !important;
    background: #fff !important;
}
.login-title{
    text-align: center;
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    padding-top: 80px;
}

.content{
        position: absolute;
        left: 50%;
        top: 55%;
        width: 860px;
        height: 450px;
        z-index: 999;
        font-size: 18px;
        margin-left: -430px;
        margin-top: -114px;
        border-radius: 10px;
        padding: 56px 100px 35px;
        box-sizing: border-box;
        .info{
            overflow: hidden;
            position: relative;
            .name{
                position: absolute;
                top: 20px;
                left: 115px;
                font-weight:bold;
            }
            .total{
                text-align: center;
                float: left;
                .mgc{
                    width: 260px;
                    height: 260px;
                    position: relative;
                    img{
                        position: absolute;
                        width: 100%;
                        top: 0;
                        left: 0;
                    }
                    .score{
                        position: absolute;
                        font-size: 46px;
                        top: 0px;
                        left: 0;
                        text-align: center;
                        width: 100%;
                        height: 260px;
                        line-height: 260px;
                        color: #fff;
                        display: flex;
                        justify-content: center;
                        align-items: baseline;
                        .unit{
                            font-size: 28px;
                        }
                    }
                }
                .tz{
                    font-size: 20px;
                    font-weight: bold;
                }
                .qualified{
                    color: #002E67;
                }
                .unqualified{
                    color: #B3B3B3;
                }
                .wait{
                    color: #808080;
                }
            }
            .detail{
                margin: auto;
                width: 205px;
                padding-top: 60px;
                & > div{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    color: #595959;
                    padding: 0 20px;
                    border-left: 4px solid #002E67;
                    margin-bottom:  31px;
                }
                &.task-detail{
                    padding-top: 90px;
                }
            }
        }
        .handle{
            position: absolute;
            bottom: 76px;
            left: 0;
            text-align: center;
            width: 100%;
            span{
                width: 150px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border: 1px solid #002E67;
                box-sizing: border-box;
                display: inline-block;
                color: #002E67;
                cursor: pointer;
                border-radius: 0px;
                &:nth-child(n+2){
                    margin-left: 20px;
                }
                &.active{
                    background: #002E67;
                    color: #fff;
                }
            }
        }
    }
    
</style>
